module.exports = __webpack_public_path__ + "img/couples-005.284fddd4.jpg";